<template>
    <div class="wrapper" :style="cssProps">
        <div class="wrapper__header">
            <div class="wrapper__header__resolution" :class="{ warning: warning }" :title="warning ? warningText : ''">
                {{ resolution }}
                <font-awesome-icon
                    style="margin-left: 3px"
                    v-if="warning"
                    size="sm"
                    :icon="['fas', 'exclamation-triangle']"
                />
            </div>
            <div class="wrapper__header__title" v-if="title">
                {{ titleText }}
            </div>
            <div class="wrapper__header__buttons">
                <button class="wrapper__header__buttons__button" v-if="setPrimaryButton" @click="onSetPrimary" type="button">
                    <font-awesome-icon title="Set Primary Photo" size="sm" :icon="['fas', 'angles-left']" />
                </button>
                <button class="wrapper__header__buttons__button" v-if="downloadButton" @click="onDownload" type="button">
                    <font-awesome-icon title="Download Photo" size="sm" :icon="['fas', 'download']" />
                </button>
                <button class="wrapper__header__buttons__button" v-if="deleteButton" @click="onDelete" type="button">
                    <font-awesome-icon title="Delete Photo" size="sm" :icon="['fas', 'trash']" />
                </button>
            </div>
        </div>
        <div class="wrapper__main">
            <div class="wrapper__main__photo" :class="{ handle: photoDraggable }">
                <img :src="photoUrl" :alt="caption" onerror="this.src='/static/images/image-placeholder.png'" />
            </div>
        </div>
        <div class="wrapper__footer">
            <button class="wrapper__footer__caption text-primary" @click="onEdit" type="button">
                <div class="truncate" :title="caption">
                    {{ caption ? caption : editCaption ? 'Add caption' : '' }}
                </div>
            </button>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        id: Number,
        resolution: String,
        warning: {
            type: Boolean,
            default: false,
        },
        warningText: {
            type: String,
            default: '',
        },
        caption: String,
        editCaption: {
            type: Boolean,
            default: false,
        },
        setPrimaryButton: {
            type: Boolean,
            default: false,
        },
        downloadButton: {
            type: Boolean,
            default: false,
        },
        deleteButton: {
            type: Boolean,
            default: false,
        },
        title: {
            type: Boolean,
            default: false,
        },
        titleText: {
            type: String,
            default: '',
        },
        photoDraggable: {
            type: Boolean,
            default: false,
        },
        photoUrl: String,
        photoHeight: {
            type: Number,
            default: 172,
        },
    },
    computed: {
        cssProps() {
            return {
                '--photo-height': this.photoHeight ? `${this.photoHeight}px` : 'auto',
            };
        },
    },
    methods: {
        onSetPrimary() {
            this.$emit('set-primary', this.id);
        },
        onDownload() {
            this.$emit('download', this.id);
        },
        onDelete() {
            this.$emit('delete', this.id);
        },
        onEdit() {
            this.$emit('edit', this.id);
        },
    },
};
</script>

<style lang="scss" scoped>
.wrapper {
    line-height: 1.42857143;
    background-color: #fff;
    border: 1px solid #e0e0e0;
    border-radius: 4px;
    box-shadow: 0 1px 2px rgba(0, 0, 0, 0.075);
    position: relative;
    padding: 9px 14px 9px;
    display: flex;
    flex-direction: column;
    position: relative;
    &__header {
        display: flex;
        justify-content: space-between;
        &__resolution {
            display: flex;
            align-items: center;
            font-size: 12px;
        }
        &__buttons {
            display: flex;
            margin-left: -10px;
            &__button {
                color: #0e47a1;
                margin-left: 10px;
                display: flex;
                justify-content: center;
                align-items: center;
                background-color: #fff;
                border: none;
                outline: none !important;
                padding: 0;
                cursor: pointer;
            }
        }
        &__title {
            position: absolute;
            top: -10px;
            left: 50%;
            transform: translateX(-50%);
            border-radius: 5px;
            border: 1px solid #e0e0e0;
            background-color: #fff;
            color: #00b74a;
            font-size: 12px;
            font-weight: 700;
            line-height: 1;
            padding: 5px;
            text-align: center;
        }
    }
    &__main {
        margin-top: 4px;
        padding: 10px;
        border: 1px solid #e0e0e0;
        height: var(--photo-height);
        &__photo {
            display: flex;
            justify-content: center;
            align-items: center;
            width: 100%;
            height: 100%;
            img {
                max-width: 100%;
                max-height: 100%;
            }
        }
    }
    &__footer {
        margin-top: 8px;
        &__caption {
            width: 100%;
            font-size: 13px;
            text-align: left;
            background-color: #fff;
            border: none;
            outline: none !important;
            padding: 0;
            cursor: pointer;
        }
    }
}
.warning {
    color: #ffa900;
}
.handle {
    cursor: move;
}
.truncate {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}
</style>
